// Get the Google Tag Manager Instance. Don't load it in China.
const dataLayer = window.dataLayer;
const hasGTM = !!dataLayer;

/**
 * Standard Events to Track using TrackEvent.
 */
export const Events = {
  EVENT_START: 'EVENT_START',
  EVENT_JOIN: 'EVENT_JOIN',
  EVENT_WATCH: 'EVENT_WATCH',
};

// Push to GTM with Error Detection.
function pushGTM(data) {
  // Google Tag Manager Tracking.
  if (dataLayer) {
    try {
      dataLayer.push(data);
    } catch (e) {
      // This will throw an error if GTM hasn't been loaded, this will be the case in China
      /* eslint-disable no-console */
      console.log('GTM pushEvent error');
    }
  }
}

/**
 * Tracks an Event in the App.
 * @param {String} event Name of the Event. Can be anything, or you can use an events from the events object.
 * @param {Object} metadata Additional Metadata to Provide to the Event.
 */
export function TrackEvent(event, metadata) {
  // Google Tag Manager Tracking.
  if (hasGTM) {
    pushGTM({ ...metadata, event });
  }
}

/**
 * Adds additional metadata to the Tracker for this Session.
 * @param {Object} metadata Additional Metadata to Provide.
 */
export function AddMetadata(metadata) {
  if (hasGTM) {
    pushGTM(metadata);
  }
}

/**
 * Reports an Error.
 * @param {*} error Error to Report.
 * @param {Object} metadata Additional Metadata for Reporting.
 */
export function ReportError(error, metadata) {
  if (console) {
    console.error(error, error.rawError); // eslint-disable-line no-console
  }
}
